import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="font-display text-3xl font-extrabold">Stránka nenalezena</h1>
      <p className="text-muted">Odkaz je neplatný nebo stránka už neexistuje.</p>
      <Link to="/" className="font-semibold text-fg underline decoration-primary decoration-2 underline-offset-4">
        Na úvodní stránku
      </Link>
    </main>
  );
}
